import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface SessionDialogData {
  icon?: string;
  iconBg?: string;
  iconColor?: string;
  heading?: string;
  message?: string;
  buttonLabel?: string;
  /** Navigation target on button click. null = close only, no redirect. Defaults to /auth/login. */
  redirectTo?: string | null;
}

@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  imports: [ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SessionTimeoutDialogComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly router = inject(Router);

  readonly dialogData: Required<SessionDialogData>;

  constructor() {
    const raw =
      (inject(DynamicDialogConfig, { optional: true })
        ?.data as SessionDialogData) ?? {};
    this.dialogData = {
      icon: raw.icon ?? 'pi pi-exclamation-triangle',
      iconBg: raw.iconBg ?? 'bg-amber-100',
      iconColor: raw.iconColor ?? 'text-amber-500',
      heading: raw.heading ?? 'Session Expired',
      message:
        raw.message ??
        'For your security, your session has timed out. Please sign in again.',
      buttonLabel: raw.buttonLabel ?? 'Sign in',
      redirectTo: raw.redirectTo !== undefined ? raw.redirectTo : '/auth/login'
    };
  }

  onOkClick(): void {
    this.ref.close();
    if (this.dialogData.redirectTo) {
      // Defer navigation so PrimeNG finishes dialog teardown before the route change.
      setTimeout(() => this.router.navigate([this.dialogData.redirectTo!]), 0);
    }
  }
}
